import {
  // Document,
  // Calendar,
  // Folder,
  // Collection,
  Right,
} from "@element-plus/icons-vue";
import iamge from '@/assets/headerimage/solution.png'
import image2 from '@/assets/headerimage/solution2.png'
import image3 from '@/assets/headerimage/solution3.png'
// import img1 from '../../assets/images/1.png'
// import img2 from '../../assets/images/2.png'
// import img3 from '../../assets/images/3.png'
const knowledgeCards = ([

  {
    id: '1',
    name: "关学文库知识服务平台",
    content:
      "通过对《关学文库》这套丛书的整合分析，内容建设分为：文献系列和学术研究系列两个部分。根据每个系列的资源特点，建设相应资源体系，并挖掘各个系列的资源共通处，提取出有关人物、组织、作品的统一内容栏目。本数据库的构建不仅可以对已有800年历史的关学文献进行系统整理，而且对关学的思想和学术系统性研究有重要参考意义。",
    category: "历史文化",
    house: '西北大学出版社',
    fileName: 'a',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    url: 'http://8.137.86.126/'
  },
  // {
  //   id:'2',
  //   name: "敦煌与丝绸之路",
  //   content:
  //     "以服务于 “一带一路”倡议为出发点，以服务于敦煌学和丝绸之路研究用户和市场需求为导向，平台构建的敦煌学和丝绸之路研究数据库，全面精准的整合了历史古文献、图书期刊论文报告、图片视频音频共3种类型的相关资源，经由数字化加工和知识组织，建成了基础资源库、全媒体素材库共2个类型的知识资源库，并在此基础上建成索引目录数据库、古文献数据库、研究成果分类特色数据库和遗珍资源库共4个类型的产品数据库。",
  //   category: "历史文化",
  //    house:'中国农业出版社',
  // },
  {
    id: '2',
    name: "青铜文化知识服务平台",
    content:
      "陕西是中国古代文明发祥地之一，也是全国出土文物最多的地方之一，特别是关中地区作为西周王朝所在地，是其时政治、经济和文化的中心地区，陕西在青铜器研究方面，可谓拥有得天独厚的条件。陕西陆续出土的西周青铜重器一次次的震惊寰宇。尤为重要的是，出土的西周青铜器及其铭文每次都能够给予世人诸多意外的收获。这些青铜器铭文对于我们研究西周时期政治、文化、军事、宗教观念等有着重要的史料价值，陕西被誉为“中国青铜器之乡”。作为国内目前收录陕西出土有铭青铜器资料最多、最全的《陕西金文集成》，不仅是专业人员对相关领域开展研究工作的基础，也应该成为优秀传统文化继承和发扬光大的宝贵知识库。但由于图书本身使用的不方便和传播的局限性，使得许多对金文有兴趣的研究人员和公众不能接触到这些宝贵资料，本项目将利用现代信息技术，建立一个“青铜文化”知识服务平台，实现陕西出土的青铜器资料数字化管理，有效存储这些珍贵资料，并使这些丰富的知识资源得到有效传播和利用。",
    category: "历史文化",
    house: '陕西三秦出版社',
    fileName: 'b',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    url: 'http://qingtongwh.com/'
  },
  {
    id: '3',
    name: "唐代壁画珍品数字馆",
    content:
      "陕西作为中华民族和华夏文化的重要发祥地之一，拥有着得天独厚的历史优势和文化底蕴，孕育了辉煌灿烂的唐代文明，在这里发掘和出土的唐墓壁画，生动地再现了“九天阊阖开宫殿，万国衣冠拜冕旒”的盛唐气象，展现出无与伦比的大唐风华。三秦出版社依托优质图书资源，运用5G技术、虚拟现实技术、大数据技术实现唐墓壁画与互联网应用的深度融合，构建了以唐墓壁画数字资源为基础，以5G+VR展示、唐墓分布时空链、“数字壁画”开发为核心功能的唐文化综合服务与体验平台。",
    category: "历史文化",
    house: '陕西三秦出版社',
    fileName: 'c',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    url: 'http://www.5gtwhbh.com/'
  },
  {
    id: '4',
    name: "延安时期红色档案数据库",
    content: "我党的发展史就是一部注重和加强自身建设的历史，对于发挥党的领导作用具有重要的引领作用，特别是在两个百年的关键时期。在此背景下，党史党建数据库建设时间紧、任务重，要稳步推进数据库建设规范与标准的研究，为党的建设工作顺利开展奠定良好的基础。本着服务于民的宗旨，搭建好数据库内容体系和平台建设，为实现资源共享、推动党史党建发挥更大作用奠定良好的基础。党史特色专题数据库的建设，一方面要完善信息化建设工作机制，科学整合现有资源；另一方面集中力量抓好数字资源的建设和开发利用，实现信息资源共建共享，建立起具有特色的信息资源库。通过党史数据库提供的知识服务，可以进一步教育党员发扬革命精神，始终保持艰苦奋斗的昂扬精神。一百年非凡奋斗，一代又一代中国共产党人顽强拼搏，形成了一系列伟大精神，构筑起中国共产党人的精神谱系，为我们立党兴党强党提供了丰厚滋养。通过党史主题学习教育，有效激发党员自觉发扬红色传统、传承红色基因，赓续共产党人精神血脉，鼓起迈进新征程、奋进新时代的精气神。",
    category: "红色党建",
    house: '陕西人民出版社',
    fileName: 'd',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    url: 'http://www.yahsda.com/'
  },
  {
    id: '5',
    name: "百年党史数据库",
    content:
      "中国共产党百年历程数据库”覆盖了中国共产党从1921年成立至2021年100年的历史,准确生动地展现了中国共产党团结全国人民为实现国家富强、人民幸福而不懈奋斗的历史进程,展现了近现代中国艰苦卓绝的发展过程,凝聚了中华民族面对”千年未有之大变局”昂首自强的奋斗历程。百年党史融合学习主题平台的设计的目的和意义是为了推动党的历史教育，让党员和群众更好地了解党的历史，发挥党史教育的积极作用。它可以帮助广大党员和群众更好地了解党的百年历史，深刻领会党的光荣传统和丰功伟业，增强党性观念和党员意识。其次，通过学习平台，可以加深对党的奋斗历程、理论创新、实践探索的认识，提高党员的政治素养和理论水平。此外，百年党史学习平台还可以促进党员和群众的思想政治教育，引导大家坚定理想信念，增强党性修养，提升党性觉悟。最终，通过学习平台，可以加强党的组织建设和制度建设，推动全党全社会不忘初心、牢记使命，为实现中华民族伟大复兴的中国梦不懈奋斗。",
    category: "红色党建",
    house: '陕西人民出版社',
    fileName: 'e',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    url: ''
  },
  {
    id: '6',
    name: "红色记忆·贵州长征国家公园公共文化服务平台",
    content:
      "平台致力于分析和展示西安秦腔丰富多样的戏曲艺术，通过整理分析陕西戏曲种类、资源内容、戏曲特色，建设栏目包括剧种、剧目、人物、戏曲资源库、脸谱、戏曲机构、",
    category: "红色党建",
    house: '贵州数字出版有限公司',
    fileName: 'f',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    url: 'https://www.gzhongsejiyi.com/'
  },
  {
    id: '7',
    name: "人卫临床助手",
    content:
      "人卫临床助手以人卫学术专著、诊疗指南、专家共识、临床病例为内容基础，为医务工作者提供医学知识查询与学习服务，为医生的临床工作进行全方位的辅助和支持。",
    category: "医疗科技",
    house: '人民卫生出版社',
    fileName: 'g',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    url: 'https://ccdas.pmphai.com/'
  },
  {
    id: '8',
    name: "中国中医药知识港",
    content:
      "中医药科普标准知识库是中华中医药学会组织建设的权威、专业、惠民、多元的中医药科普公益平台，旨在发挥学会专家资源优势，构建科学、规范、标准的中医药科普知识内容，促进中医药健康科普与文化传播，提高公众对中医药的获得感，助力“健康中国”建设。",
    category: "医疗科技",
    house: '福建科学技术出版社',
    fileName: 'h',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    url: ''
  },
  {
    id: '9',
    name: "中华医学会",
    content:
      "中华医学会成立于1915年，是中国医学科技工作者自愿组成并依法登记的学术性、非营利性社会组织，是发展我国医学科学技术和卫生事业的重要社会力量。 在党和政府的亲切关怀和全体会员的共同努力下，中华医学会不断发展壮大，经过百年的励精图治，已经成为党和政府联系医学科技工作者的桥梁和纽带、中国科协学会之翘楚、全国医学科技工作者之家。",
    category: "医疗科技",
    house: '陕西人民出版社',
    fileName: 'i',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    url: ''
  },
  {
    id: '10',
    name: "人卫中医助手",
    content:
      "人卫中医助手是以中医基础理论、中医诊疗学、中医药方剂学、针灸学等经典图书为内容基础，辅以视频图片等资源，建设以中医病证知识库、中医经典病例库、中药方剂检索库、针灸查询为主要内容的中医临床决策辅助系统。通过建立完善中医病证知识的形成及更新机制，为中医从业者、中医学生、国际中医爱好者提供专业知识服务平台，以及提供符合当下环境并且具有一定前瞻性的临床决策支持。并结合中医临床实际和诊病特点，建立提交、标引及发布机制，采集标准化病例，作为临床决策辅助信息。方便中医从业者、中医学生、国际中医爱好者综合中医理论基础、辨证论治思路、中医诊断学、经典病例等多重信息进行学习，方便中医从业者结合具体病情及实际诊疗条件做出最适合的临床决策。",
    category: "医疗科技",
    house: '人民卫生出版社',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    fileName: 'j',
    url: 'https://rwzyzs.pmphai.com/'
  },
  {
    id: '11',
    name: "人卫用药助手",
    content:
      "人卫用药助手是人卫智慧服务平台学术子平台的重要组成部分，以用户临床用药实践需求为导向，以提供智慧智能的用药知识服务为目标，为广大的医、药、护、技专业人员提供科学、权威、前沿、实用的药学知识服务。",
    category: "医疗科技",
    house: '人民卫生出版社',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    fileName: 'k',
    url: 'https://pharmacy.pmphai.com/'
  },
  {
    id: '12',
    name: "中国电力百科网",
    content:
      "中国电力百科网（www.ceppedu.com）是在国家电网公司的支持下，由中国电力出版社有限公司倾力打造的一体化知识服务平台。电百网依托电力行业背景和独家资源优势，构建权威的电力科技知识资源数据库，打造专业的能源语义搜索引擎，按照内容服务—信息服务—知识服务路径，提供智能检索、知识图谱、实验室共享、融合出版、期刊投稿、辅助决策等多元场景化知识服务，支撑电力知识普及、学习，以及电力科技创新与成果传播。",
    category: "信息技术",
    house: '中国电力出版社',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    fileName: 'l',
    url: 'https://www.ceppedu.com/'
  },
  {
    id: '13',
    name: "航空工业知识服务平台",
    content:
      "《航空工业知识服务平台》 整合了中航出版传媒有限责任公司回溯的图书、期刊、手册、视频、图片等多种资源，对国内外出版的一些航空类专业资源进行深度数字化加工，主要面向一线科研人员和航空类院校师生提供服务。平台资源分类体系符合航空工业发展要求灵活的模块化定制。为航空工业教学、生产和管理提供多专业、多维度的信息资源与数据服务。平台实现资源的聚合，致力于有效解决目前航空垂直领域资源较为分散，多平台不同体系等难题。",
    category: "信息技术",
    house: '中航出版传媒有限责任公司',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    fileName: 'm',
    url: 'https://www.aviationnow.com.cn/'
  },
  {
    id: '14',
    name: "中国社会科学年鉴数据库",
    house: '中国社会科学出版社',
    date: '2024-11-26',
    num: '200家',
    category: "人文社科",
    fileName: 'n',
    content: '“中国社会科学年鉴系列”是由中国社会科学院主办的大型学术出版项目，该项目以学术年鉴集合出版之形式记录学术、学科之变化，为学术文献的整理保存提供了重要平台，开拓了学术存史新境界。 “中国社会科学年鉴系列”是由中国社会科学院主办的大型学术出版项目，该项目以学术年鉴集合出版之形式记录学术、学科之变化，为学术文献的整理保存提供了重要平台，开拓了学术存史新境界。“中国社会科学年鉴系列”是由中国社会科学院主办的大型学术出版项目，该项目以学术年鉴集合出版之形式记录学术、学科之变化，为学术文献的整理保存提供了重要平台，开拓了学术存史新境界。',
    way: '网络访问',
    url: 'https://www.eyearbook.cn/'
  },
  {
    id: '15',
    name: "中国社会科学文库",
    house: '中国社会科学出版社',
    date: '2024-11-26',
    category: "人文社科",
    content: '“中国社会科学文库”是中国社会科学出版社自主研发、自主运营的哲学社会科学学术资源服务平台，目前包含学术电子书26000余种、论文11万篇、知识条目101万条、图片图表130万幅、科研工具4个，以及大量音视频资源，累计为1000余家机构用户提供服务。   “中国社会科学年鉴系列”是由中国社会科学院主办的大型学术出版项目，该项目以学术年鉴集合出版之形式记录学术、学科之变化，为学术文献的整理保存提供了重要平台，开拓了学术存史新境界。“中国社会科学年鉴系列”是由中国社会科学院主办的大型学术出版项目，该项目以学术年鉴集合出版之形式记录学术、学科之变化，为学术文献的整理保存提供了重要平台，开拓了学术存史新境界。',
    way: '网络访问',
    num: '200家',
    fileName: 'o',
    url: "https://www.sklib.cn/?ref=lgo"
  }
  ,
  {
    id: '16',
    name: "皮书数据库",
    house: '社会科学文献出版社',
    date: '2024-11-26',
    category: "智汇三农",
    content: '皮书数据库以皮书系列研究报告为基础，全面整合中国发展与中国经验、世界经济与国际关系领域的研究文献、实证报告、调研数据和媒体资讯，基于学术研究脉络构建子库产品，追踪社会热点推出学术专题，依托皮书研创力量着力建设学术共同体，提供以满足用户需求为目标的文献查询和知识服务，是深度分析解读当今中国与世界经济社会发展现状与未来趋势的智库成果整合与知识服务平台',
    way: '网络访问',
    num: '200家',
    fileName: 'p',
    url: 'https://www.pishu.com.cn/skwx_ps/database?SiteID=14'
  }
  ,
  {
    id: '17',
    name: "农业专业知识服务系统",
    house: '中国农业科学院农业信息研究所',
    date: '2024-11-26',
    category: "农业",
    content: '平台以大数据智能技术为依托，以农业经营主体需求为导向，构建面向农业农村场景的农业智能知识服务云平台，支持线上线下交互、生产销售业务自适应协同、个性化信息推荐、农情预测、知识问答、病虫害诊断、产业专题等智能服务，满足不同场景对农情信息智能知识服务的需求。',
    way: '网络访问',
    num: '200家',
    fileName: 'q',
  },

  {
    id: '18',
    name: "智汇三农",
    house: '中国农业出版社',
    date: '2024-11-26',
    category: "农业",
    content: '“智汇三农”农业专业知识服务平台是由中国农业出版社精心打造的多媒体、多终端的专业智能平台。其宗旨在于汇聚农业领域内的权威专业知识，构建农业领域产学研知识服务社区，以大数据、语义分析、云计算技术为支撑，建立内容、用户、企业、政府之间的互动和关联，促进各类型出版物、知识内容的多形态融合和多渠道传播',
    way: '网络访问',
    num: '200家',
    fileName: 'r',
    url: 'https://www.pwsannong.com/'

  },

  {
    id: '19',
    name: "本草风物志·中草药数据库",
    house: '贵州数字出版有限公司',
    date: '2024-11-26',
    content: '数据库综合参考了《中华本草·苗药卷》《中国常用中草药彩色图谱》《贵州民族常用天然药物》等专著，将这些精选图书进行数字碎片化收录。目前数据库包含中草药6000余种，图像资料9000多张，知识条目上万条，从药物类别、临床科目、性味、主治功效等多个纬度进行功能归类，对每一味中草药的介绍涉及其各种命名、基原、形态、资源、性味、用法、考证、临床应用、药理学研究等多方面。同时根据《新编药歌五百解》等一些经典的中草药图书建立了“药歌”、“茶药”、“贵州少数民族医药精选”等专题。用户可以在数据库中进行中草药条目查询、专题学习、高清电子书阅读，为用户提供最全面、快捷、方便的信息查询途径。',
    category: "生态环境",
    way: '网络访问',
    num: '200家',
    fileName: 's',
    url: 'https://www.gzzcybk.com/'

  },
  {
    id: '20',
    name: "全球变化科学研究数据出版系统",
    house: '中国科学院地理科学与资源研究所',
    date: '2024-11-26',
    content: '全球变化科学研究数据出版系统是中国科学院地理科学与资源研究所、中国地理学会主办，国际科学技术数据委员会（CODATA）发展中国家任务组、肯尼亚Jemo Kenyatta 农业与技术大学（JKUAT）、数字化林超地理博物馆联合协办的、以全球变化科学研究数据出版为核心、在国家科技部科技信息研究所DOI中国管理中心注册的出版系统。全球变化科学研究数据出版系统是一个关于地球科学，特别是在全球环境变化方面的开放数据基础设施。',
    way: '网络访问',
    num: '200家',
    fileName: 't',
    category: "生态环境",
    url: 'https://geodoi.ac.cn/WebCn/Default.aspx'
    ,
  },
  {
    id: '21',
    name: "中国植物志库",
    house: '中国科技出版传媒股份有限公司',
    date: '2024-11-26',
    category: "生态环境",
    content: '中国生物志库是我国首个权威发布且具有完整知识产权的中国生物物种全信息数据库，收录了近10万种中国现生生物物种。此为中国生物志库植物部分，记录了我国所有植物资源4万余种的生物学信息。包括植物的权威名称、分类地位、形态特征、分布、功用、理论知识等内容。每一种植物均配有彩色照片或者黑白线描图。库中每一条物种信息、每一张图片、每一个理论知识均经过专家的科研论证与权威鉴定，可供植物学、农林、医药、海洋、生态、检验检疫等科研人员、教师和学生查询和学习，也可供普通大众全面学习中国植物科学知识使用。',
    way: '网络访问',
    num: '200家',
    fileName: 'u',
    url: 'https://species.sciencereading.cn/biology/v/botanyIndex/122/ZW.html'
  },
  {
    id: '22',
    name: "中国自然生态百科数据库",
    house: '海峡书局出版社有限公司',
    date: '2024-11-26',
    category: "生态环境",
    content: '《中国自然生态百科数据库》是由国家林业和草原局业务指导，中国野生动物保护协会、海峡书局和飞羽视界文化开发建设的。本影像数据库内容将涵盖动物界、植物界...',
    way: '网络访问',
    num: '200家',
    fileName: 'v',

  },
  {
    id: '23',
    name: "中国古生物地层知识库",
    house: '中国科技出版传媒股份有限公司',
    date: '2024-11-26',
    category: "生态环境",
    content: '中国古生物地层知识库以《中国古生物志》《中国古脊椎动物志》《中国各门类化石》等权威古生物学与地层学专著为内容基础，将文本数字化并形成结构化数据库。具有对物种和地层信息、理论知识、术语解释进行浏览、检索、筛选的功能，并将各子库的相关信息进行互链以方便追索，为相关专业的科研与生产工作者提供知识服务。',
    way: '网络访问',
    num: '200家',
    fileName: 'w',
    url: 'https://nature.hxsjcbs.com/index.php?s=/home/index/index.html'

  },
  {
    id: '24',
    name: "新基建信息产业知识库",
    house: '人民邮电出版社有限公司',
    date: '2024-11-26',
    category: "建筑",
    content: '是由人民邮电出版社联合电子工业出版社共同打造的专业服务平台。 内容涵盖计算机，智能制造，电子通信、人工智能、大数据、物联网、产业互联网等，汇集近百位顶级学者，囊括国内外优质产教融合资源。 该平台拥有专业课程1700小时，教材6000册。 专业课程年更新200小时，教材教参年更新1000本。',
    way: '网络访问',
    num: '200家',
    fileName: 'x',

  },
  {
    id: '25',
    name: "丝绸之路历史文化数字资源平台",
    house: '兰州大学出版社',
    date: '2024-11-26',
    category: "一带一路",
    content: '丝绸之路历史文化数字资源平台是中央文化产业发展专项资金资助，兰州大学 出版社和兰州大学敦煌学研究所共同开发出版的，以丝绸之路历史文化为主题的专业数字资源库。它以兰州大学出版社“欧亚历史文化文库”丛书和“中亚与西北边疆研究”丛书为基础，整合了国内有关（陆上）丝绸之路历史地理、文物考古、文 学艺术、方志文献、中外交流等领域的图书、论文、图片、影像、史料文献等资源，面向专业知识群体和科研机构的共同知识需求，构建的集多终端应用于一体的数字资源管理系统。系统还利用电子地图技术直观呈现丝绸之路沿线的历史重镇和人文遗存，为学术研究和文物保护机构、专家学者、文化爱好者提供文献保障服务及生动可视的用户体验',
    way: '网络访问',
    num: '200家',
    fileName: 'y',
    url: 'https://www.nicksp.cn/'

  },
  {
    id: '26',
    name: "5G丝路数字文化服务平台",
    house: '陕西三秦出版社',
    date: '2024-11-26',
    category: "一带一路",
    content: '陕西西安是丝绸之路的起点，是中华文明和中华民族重要发祥地之一，有着辉煌灿烂的历史。5G丝路数字文化服务平台凭借5G通讯技术高速率、低延迟、高密度的特点，将高清图片、高清视频结合起来，以丝绸之路中国段的22处世界文化遗产点为根本，VR影像资料为媒介,足不出户便可“云游”丝路遗址，720度全景参观游览，聆听讲解，身临其境地了解丝绸之路的历史，真实感受丝绸之路的壮美，深刻领悟丝绸之路的意义和内涵。平台将历史遗迹、风土人情、视觉艺术等元素通过5G、大数据以及多媒体数字技术交叉融合，不但是对总书记“一带一路”方针的实际践行，又能起到坚定文化自信、传承中华优秀传统文化的独特作用。',
    way: '网络访问',
    num: '200家',
    fileName: 'z',
    url: 'http://5g.slwhpt.com/imgList/4.html'

  },
  {
    id: '27',
    name: "中国茶文化资源库",
    house: '海峡书局阳版社有限公司',
    date: '2024-11-26',
    category: "历史文化",
    content: '中国茶文化资源库提取、整理各类茶古籍文献数据，建设全面、权威的中国茶古籍文献数据库。开发茶文化传播应用平台，提供专业的茶文化知识服务。资源库建设内容提取5万件以上与茶传播有关的资料，按国别、线路、专题分类入库；以版权购买、版权引进等方式扫描入库1万种以上茶书数据；开发文献录入、审校系统，查询检索系统及茶文化专题数据提取系统。',
    way: '网络访问',
    num: '200家',
    fileName: 'aa',

  },
  {
    id: '28',
    name: "云南少数民族影像数字化平台",
    house: '云南少数民族影像数字化平台',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    category: "历史文化",
    fileName: 'bb',
    content: '该平台以云南少数民族的相关影像资料为核心内容，收录云南建筑、民族文化、云南旅游等反映民族特色的图片视频，有利于本地文化的宣传和旅游发展。',
  },
  {
    id: '29',
    name: "岭南文化智慧知识库",
    house: '广东人民出版社有限公司',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    category: "历史文化",
    content: '《岭南文库》是一套全面地、历史地、系统地反映和论述岭南（包括广东以及与广东在历史上、地理上有密切关系的一些岭南地域）历史政治、经济发展、社会文化、自然资源、人物业绩等方面的大型综合性丛书。《岭南文库》由岭南文库编辑委员会和广东中华民族文化促进会合编，由广东人民出版社出版。《岭南文库》出书已逾100种；其姐妹丛书《岭南文化知识书系》出书已逾200种，这300多种著作蔚为大观，显示了岭南文化的深厚内涵。',
    fileName: 'cc',

  },
  {
    id: '30',
    name: "中国传统戏曲文化资源库",
    fileName: 'dd',
    house: '中国书籍出版社',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    category: "历史文化",
    content: '该库以丰富的戏曲类图书出版资源为依托，通过数字化加工，支持全文检索、在线阅读、下载，支持数据挖掘和内容重组，倾力打造的面向戏曲领域的全面、权威、便捷的数字化知识服务平台。现入库资源共计3200万字、珍稀图片7218张（包括老照片、老戏单、脸谱等）。',
  },
  {
    id: '31',
    name: "汉中羌文化资源库",
    house: '汉中市文化馆',
    date: '2024-11-26',
    fileName: 'ee',
    way: '网络访问',
    num: '200家',
    category: "历史文化",
    content: '羌族是我国历史最为悠久的羌族是我国历史最为悠久的民族之一，羌族文化是中国多民族文化中重要的组成部分，发展壮大羌族文化对于发扬中国文化具有重要的意义。羌族文化数据库的建设不仅能充分保护利用好本地区的宝贵资源，完善补充我国相关特色数据库建设、保存国家文化遗产、丰富我国文献资源。还能够让民众领略传统民族文化的独特意义，共享特色文化的盛宴，对民族文化历史的保护、传承、发展，开发和利用更起着不可估量的作用。该数据库围绕羌族历史、生活、文化、相关研究等维度，从知识服务、数据管理、体系分类管理、统计管理和新闻管理五个方面进行构建。',

  },
  {
    id: '32',
    name: "苏州吴文化资源库",
    house: '中国农业出版社',
    date: '2024-11-26',
    fileName: 'ff',
    way: '网络访问',
    num: '200家',
    category: "历史文化",
    content: '吴文化资源主要涵盖了苏州及环太湖地区的吴文化数据信息，涉及吴地春秋、文学艺术、文化遗迹、工艺美术、吴地科教、宗教民俗、吴地名胜、现代苏州、吴地研究等主要栏目。数据库中尤显珍贵的是收集到的众多老照片，反映了苏州的历史建筑和风土人情，用户只需要登录吴文化网站就可以查找到吴文化数据库的信息，网站的搜索功能也更方便用户使用。',
  },
  {
    id: '33',
    name: "中华文化东盟学习平台",
    house: '广西师范大学出版社集团有限公司',
    date: '2024-11-26',
    fileName: 'gg',
    way: '网络访问',
    num: '200家',
    category: "信息技术",
    content: '平台将《论语》《老子》《孙子兵法》等中华文化典籍以及其他反映中华文化精髓的汉语、汉字、书法等专题内容制作成融文字、图片、动漫、音频、视频等多媒介于一体的优质数字文化资源，译成东盟及海上丝路国家主要官方语言，结合在线社区互动，实现中华文化面向东盟及海上丝路国家的富有生命力的长久传播，满足双向文化交流的需求。',
    url: 'http://www.ctcasean.com/'

  },
  {
    id: '34',
    name: "中国高校外语慕课平台",
    fileName: 'hh',
    house: '北京外研在线数字科技有限公司',
    date: '2024-11-26',
    way: '网络访问',
    num: '200家',
    category: "信息技术",
    content: '',
    url: 'https://umoocs.unipus.cn/?t=1733657094'

  },
  // 其他卡片数据...
]);

const cards = ([
  {
    id: '1',
    title: "延安时期文献档案数据库",
    date: "2024年12月-2035年12月",
    // icon: Document,
    today: '10天',
    icon2: Right,
  },
  {
    id: '2',
    title: "国家版本数据中心",
    date: "2024年12月-2035年12月",
    today: '12天',
    // icon: Calendar,
    icon2: Right,
  },
  {
    id: '3',
    title: "汉调恍恍资源管理平台",
    date: "2024年12月-2035年12月",
    // icon: Folder,
    today: '15天',
    icon2: Right,
  },
  {
    id: '4',
    title: "西安秦腔剧本精编",
    date: "2024年12月-2035年12月",
    today: '15天',
    // icon: Collection,
    icon2: Right,
  },
  {
    id: '5',
    title: "中国共产党百年党史资...",
    date: "2024年12月-2035年12月",
    // icon: Collection,
    today: '20天',
    icon2: Right,
  },
  {
    id: '6',
    title: "丝路物语专题库",
    date: "2024年12月-2035年12月",
    // icon: Collection,
    today: '11天',
    icon2: Right,
  },
  // 其他卡片数据...
]);

// 在组件逻辑中（如 setup）
const imgUrlList = {
  a: [
    new URL('../../assets/images/1.png', import.meta.url).href,
    new URL('../../assets/images/2.png', import.meta.url).href,
    new URL('../../assets/images/3.png', import.meta.url).href
  ],
  b: [
    new URL('../../assets/images/4.png', import.meta.url).href,
    new URL('../../assets/images/5.png', import.meta.url).href,
    new URL('../../assets/images/6.png', import.meta.url).href
  ],
  c: [new URL('../../assets/images/7.png', import.meta.url).href,
  new URL('../../assets/images/8.png', import.meta.url).href,
  new URL('../../assets/images/9.png', import.meta.url).href],
  d: [
    new URL('../../assets/images/10.png', import.meta.url).href,
    new URL('../../assets/images/11.png', import.meta.url).href,
    new URL('../../assets/images/12.png', import.meta.url).href
  ],
  e: [
    new URL('../../assets/images/13.png', import.meta.url).href,
    new URL('../../assets/images/14.png', import.meta.url).href,
    new URL('../../assets/images/15.png', import.meta.url).href
  ],
  f: [new URL('../../assets/images/6.png', import.meta.url).href,
  new URL('../../assets/images/7.png', import.meta.url).href,
  new URL('../../assets/images/8.png', import.meta.url).href],
  g: [
    new URL('../../assets/images/19.png', import.meta.url).href,
    new URL('../../assets/images/20.png', import.meta.url).href,
    new URL('../../assets/images/21.png', import.meta.url).href
  ],
  h: [
    new URL('../../assets/images/22.png', import.meta.url).href,
    new URL('../../assets/images/23.png', import.meta.url).href,
    new URL('../../assets/images/24.png', import.meta.url).href
  ],
  i: [
    new URL('../../assets/images/25.png', import.meta.url).href,
    new URL('../../assets/images/26.png', import.meta.url).href,
    new URL('../../assets/images/27.png', import.meta.url).href
  ],
  j: [
    new URL('../../assets/images/28.png', import.meta.url).href,
    new URL('../../assets/images/29.png', import.meta.url).href,
    new URL('../../assets/images/30.png', import.meta.url).href
  ],
  k: [new URL('../../assets/images/19.png', import.meta.url).href,
  new URL('../../assets/images/20.png', import.meta.url).href,
  new URL('../../assets/images/21.png', import.meta.url).href],
  l: [new URL('../../assets/images/34.png', import.meta.url).href,
  new URL('../../assets/images/35.png', import.meta.url).href,
  new URL('../../assets/images/36.png', import.meta.url).href],
  m: [new URL('../../assets/images/37.png', import.meta.url).href,
  new URL('../../assets/images/38.png', import.meta.url).href,
  new URL('../../assets/images/39.png', import.meta.url).href],
  n: [new URL('../../assets/images/40.png', import.meta.url).href,
  new URL('../../assets/images/41.png', import.meta.url).href,
  new URL('../../assets/images/42.png', import.meta.url).href],
  o: [new URL('../../assets/images/43.png', import.meta.url).href,
  new URL('../../assets/images/44.png', import.meta.url).href,
  new URL('../../assets/images/45.png', import.meta.url).href],
  p: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  q: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  r: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  s: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  t: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  u: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  v: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  w: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  x: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  y: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  z: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/5.png', import.meta.url).href,
  new URL('../../assets/images/6.png', import.meta.url).href],
  aa: [new URL('../../assets/images/14.png', import.meta.url).href,
  new URL('../../assets/images/15.png', import.meta.url).href,
  new URL('../../assets/images/36.png', import.meta.url).href],
  bb: [new URL('../../assets/images/4.png', import.meta.url).href,
  new URL('../../assets/images/35.png', import.meta.url).href,
  new URL('../../assets/images/36.png', import.meta.url).href],
  cc: [new URL('../../assets/images/44.png', import.meta.url).href,
  new URL('../../assets/images/25.png', import.meta.url).href,
  new URL('../../assets/images/26.png', import.meta.url).href],
  dd: [new URL('../../assets/images/55.png', import.meta.url).href,
  new URL('../../assets/images/56.png', import.meta.url).href,
  new URL('../../assets/images/57.png', import.meta.url).href],
  ee: [new URL('../../assets/images/14.png', import.meta.url).href,
  new URL('../../assets/images/15.png', import.meta.url).href,
  new URL('../../assets/images/26.png', import.meta.url).href],
  ff: [new URL('../../assets/images/11.png', import.meta.url).href,
  new URL('../../assets/images/25.png', import.meta.url).href,
  new URL('../../assets/images/26.png', import.meta.url).href],
  gg: [new URL('../../assets/images/24.png', import.meta.url).href,
  new URL('../../assets/images/25.png', import.meta.url).href,
  new URL('../../assets/images/36.png', import.meta.url).href],
  hh: [new URL('../../assets/images/21.png', import.meta.url).href,
  new URL('../../assets/images/15.png', import.meta.url).href,
  new URL('../../assets/images/26.png', import.meta.url).href],
};

const newData = (
  [
    {
      "areaCode": "北京",
      "bussinessCid": "",
      "contactPerson": "",
      "contactPhone": "",
      "contentCid": "385",
      "contentFrom": "来源于《中国水利统计年鉴》收录了历年全国和各省、自治区、直辖市的水资源、水环境、水利建设投资、水利工程设施、水电等方面的统计数据，以及新中国成立以来的全国主要水利统计数据，全面反映我国水利发展情况。",
      "createBy": "",
      "createTime": "2025-03-20 13:58:50",
      "dataCount": 2000,
      "dataFunction": "",
      "description": "中国水利年鉴数据库将1990年至今《中国水利年鉴》内容资源进行数字化处理和多维度呈现，反映中国水利事业发展和记录水利事实、汇集水利统计资料，充分发挥《年鉴》的实用性和存史性两大特点。",
      "descroptionHtml": "中国水利年鉴数据库将1990年至今《中国水利年鉴》内容资源进行数字化处理和多维度呈现，反映中国水利事业发展和记录水利事实、汇集水利统计资料，充分发挥《年鉴》的实用性和存史性两大特点。",
      "id": "1645138c2f964dbaa14a53782023c14c",
      "images": [],
      "imgUrl": "",
      "isUp": false,
      "keyWord": "",
      "mirrorPrice": 150000,
      "mirrorVersion": 1,
      "netPrice": 50000,
      "netVersion": 1,
      "orgId": "",
      "pageIndex": null,
      "pageSize": null,
      "publishDate": "0001-01-01 00:00:00",
      "publishUnit": "中国水利水电出版社",
      "publishUnitHtml": "中国水利水电出版社",
      "remark": "",
      "sort": 0,
      "status": "1",
      "title": "中国水利年鉴数据库",
      "titleHtml": "中国水利年鉴数据库",
      "updateBy": "",
      "updateTime": "0001-01-01 00:00:00",
      "webUrl": "",
      "word": "",
      'mss': 'HOT',
      'color': 'f7cf01'
    },
    {
      "areaCode": "北京",
      "bussinessCid": "",
      "contactPerson": "",
      "contactPhone": "",
      "contentCid": "385",
      "contentFrom": "来源于《江河水利志书》真实记载和反映了我国不同时期江河治理和水利发展方方面面的成果，在镜鉴水利决策、优化水利规划设计、完善江河治理策略和推进新时期水利事业等方面，发挥了重要的纪实存史以及资治功用。",
      "createBy": "",
      "createTime": "2025-03-20 13:58:50",
      "dataCount": 2000,
      "dataFunction": "",
      "description": "江河水利志书真实记载和反映了我国不同时期江河治理和水利发展方方面面的成果，在镜鉴水利决策、优化水利规划设计、完善江河治理策略和推进新时期水利事业等方面，发挥了重要的纪实存史以及资治功用。中国现代江河水利志数据库实现江河水利志书的数字化，实现了资源共享、信息增值，为水利工作者及高校师生提供方便快捷的查阅参考功能。",
      "descroptionHtml": "江河水利志书真实记载和反映了我国不同时期江河治理和水利发展方方面面的成果，在镜鉴水利决策、优化水利规划设计、完善江河治理策略和推进新时期水利事业等方面，发挥了重要的纪实存史以及资治功用。中国现代江河水利志数据库实现江河水利志书的数字化，实现了资源共享、信息增值，为水利工作者及高校师生提供方便快捷的查阅参考功能。",
      "id": "166235bff60440fbb3a9d0393ef6afff",
      "images": [],
      "imgUrl": "/profile/knowledge/2025/03/26/b5c734cf-c766-4862-acdc-03b72a6cb2ff.png",
      "isUp": false,
      "keyWord": "",
      "mirrorPrice": 150000,
      "mirrorVersion": 1,
      "netPrice": 50000,
      "netVersion": 1,
      "orgId": "",
      "pageIndex": null,
      "pageSize": null,
      "publishDate": "0001-01-01 00:00:00",
      "publishUnit": "中国水利水电出版社",
      "publishUnitHtml": "中国水利水电出版社",
      "remark": "",
      "sort": 0,
      "status": "1",
      "title": "中国现代江河水利志数据库",
      "titleHtml": "中国现代江河水利志数据库",
      "updateBy": "",
      "updateTime": "0001-01-01 00:00:00",
      "webUrl": "",
      "word": "",
      'mss': 'NEW',
      'color': '#316eb3'
    },
    {
      "areaCode": "北京",
      "bussinessCid": "",
      "contactPerson": "",
      "contactPhone": "",
      "contentCid": "385",
      "contentFrom": "以《中国河湖大典》系列图书为基础开发，将全国范围包括港澳台地区在内的河湖和重要水体进行了详细、完整、有序的梳理和描述，涉及地理、历史、环境、生态、农业、文化、经济和社会等诸多领域，是我国江河湖泊历史、现实面貌和治水实践的真实写照和百科全书。",
      "createBy": "",
      "createTime": "2025-03-20 13:58:50",
      "dataCount": 2000,
      "dataFunction": "",
      "description": "中国水利统计年鉴数据库将2009年至今《中国水利统计年鉴》内容资源进行数字化处理和多维度呈现，系统收录了历年全国和各省、自治区、直辖市的水资源、水环境、水利建设投资、水利工程设施、水电等方面的统计数据，以及新中国成立以来的全国主要水利统计数据，全面反映我国水利发展情况。碎片化重组后的数字内容，不仅完整呈现了所有数据，更为用户展现了数据深度组合的可能性和实用价值。",
      "descroptionHtml": "中国水利统计年鉴数据库将2009年至今《中国水利统计年鉴》内容资源进行数字化处理和多维度呈现，系统收录了历年全国和各省、自治区、直辖市的水资源、水环境、水利建设投资、水利工程设施、水电等方面的统计数据，以及新中国成立以来的全国主要水利统计数据，全面反映我国水利发展情况。碎片化重组后的数字内容，不仅完整呈现了所有数据，更为用户展现了数据深度组合的可能性和实用价值。",
      "id": "5b9e4f10ac4740ac9d844022893d3c2b",
      "images": [],
      "imgUrl": "/profile/knowledge/2025/03/26/f09308f6-9b34-41cc-8338-8294dffa3e13.png",
      "isUp": false,
      "keyWord": "",
      "mirrorPrice": 150000,
      "mirrorVersion": 1,
      "netPrice": 50000,
      "netVersion": 1,
      "orgId": "",
      "pageIndex": null,
      "pageSize": null,
      "publishDate": "0001-01-01 00:00:00",
      "publishUnit": "中国水利水电出版社",
      "publishUnitHtml": "中国水利水电出版社",
      "remark": "",
      "sort": 0,
      "status": "1",
      "title": "中国水利统计年鉴数据库",
      "titleHtml": "中国水利统计年鉴数据库",
      "updateBy": "",
      "updateTime": "0001-01-01 00:00:00",
      "webUrl": "",
      "word": ""
    },
    {
      "areaCode": "北京",
      "bussinessCid": "",
      "contactPerson": "",
      "contactPhone": "",
      "contentCid": "385",
      "contentFrom": "",
      "createBy": "",
      "createTime": "2025-03-20 13:58:50",
      "dataCount": 2000,
      "dataFunction": "",
      "description": "《中国河湖大典》数据库以《中国河湖大典》系列图书为基础开发，将全国范围包括港澳台地区在内的河湖和重要水体进行了详细、完整、有序的梳理和描述，涉及地理、历史、环境、生态、农业、文化、经济和社会等诸多领域，是我国江河湖泊历史、现实面貌和治水实践的真实写照和百科全书。",
      "descroptionHtml": "《中国河湖大典》数据库以《中国河湖大典》系列图书为基础开发，将全国范围包括港澳台地区在内的河湖和重要水体进行了详细、完整、有序的梳理和描述，涉及地理、历史、环境、生态、农业、文化、经济和社会等诸多领域，是我国江河湖泊历史、现实面貌和治水实践的真实写照和百科全书。",
      "id": "64a4b011fc6c4702b9404f14ae83df6f",
      "images": [],
      "imgUrl": "/profile/knowledge/2025/03/26/7e5af20a-28d3-40f2-90a3-b8d968b384aa.png",
      "isUp": false,
      "keyWord": "",
      "mirrorPrice": 150000,
      "mirrorVersion": 1,
      "netPrice": 50000,
      "netVersion": 1,
      "orgId": "",
      "pageIndex": null,
      "pageSize": null,
      "publishDate": "0001-01-01 00:00:00",
      "publishUnit": "中国水利水电出版社",
      "publishUnitHtml": "中国水利水电出版社",
      "remark": "",
      "sort": 0,
      "status": "1",
      "title": "中国河湖大典数据库",
      "titleHtml": "中国河湖大典数据库",
      "updateBy": "",
      "updateTime": "0001-01-01 00:00:00",
      "webUrl": "",
      "word": "",
      'mss': 'NEW',
      'color': '#316eb3'
    },
    {
      "areaCode": "北京",
      "bussinessCid": "",
      "contactPerson": "",
      "contactPhone": "",
      "contentCid": "385",
      "contentFrom": "",
      "createBy": "",
      "createTime": "2025-03-20 13:58:50",
      "dataCount": 2000,
      "dataFunction": "",
      "description": "中国经典水利史料数据库收录了经点校整理、繁体排录、全文数字化后的水利重要古籍2000余万字，水利经典古籍、历代治河奏折呈表、海内外各藏书机构中的珍稀地图，以及围绕每个重大水利事件的谕旨奏章。该库用数字化的手段将中国古代经典水文化与现代专家学者的智慧成果进行整合挖掘，实现资源的共享、信息的增值，提供翔实、可靠的史料参考。",
      "descroptionHtml": "中国经典水利史料数据库收录了经点校整理、繁体排录、全文数字化后的水利重要古籍2000余万字，水利经典古籍、历代治河奏折呈表、海内外各藏书机构中的珍稀地图，以及围绕每个重大水利事件的谕旨奏章。该库用数字化的手段将中国古代经典水文化与现代专家学者的智慧成果进行整合挖掘，实现资源的共享、信息的增值，提供翔实、可靠的史料参考。",
      "id": "7e3b8fc902564d928e8113ea5234e9fb",
      "images": [],
      "imgUrl": "",
      "isUp": false,
      "keyWord": "",
      "mirrorPrice": 150000,
      "mirrorVersion": 1,
      "netPrice": 50000,
      "netVersion": 1,
      "orgId": "",
      "pageIndex": null,
      "pageSize": null,
      "publishDate": "0001-01-01 00:00:00",
      "publishUnit": "中国水利水电出版社",
      "publishUnitHtml": "中国水利水电出版社",
      "remark": "",
      "sort": 0,
      "status": "1",
      "title": "中国经典水利史料数据库",
      "titleHtml": "中国经典水利史料数据库",
      "updateBy": "",
      "updateTime": "0001-01-01 00:00:00",
      "webUrl": "",
      "word": ""
    },
    {
      "areaCode": "北京",
      "bussinessCid": "",
      "contactPerson": "",
      "contactPhone": "",
      "contentCid": "385",
      "contentFrom": "来源于黄河水利古地图约1900余幅，《行水金鉴》（黄河部分）2册电子书，黄河流域灌溉工程遗产视频资料4个。",
      "createBy": "",
      "createTime": "2025-03-20 13:58:50",
      "dataCount": 2000,
      "dataFunction": "",
      "description": "中国黄河水利古地图数字资源库收录黄河水利古地图约1900余幅，《行水金鉴》（黄河部分）2册电子书，黄河流域灌溉工程遗产视频资料4个。数据库收录内容表现形式有图片、电子书、视频等，是以视听材料为主的黄河文化专题库。数据库对所收录古地图进行了深度标引和大众化解读，通过数字化形式完成了信息收集和知识架构，作为黄河文化的专题库能为黄河文化的广泛宣传和深入研究提供有效的数据支撑。",
      "descroptionHtml": "中国黄河水利古地图数字资源库收录黄河水利古地图约1900余幅，《行水金鉴》（黄河部分）2册电子书，黄河流域灌溉工程遗产视频资料4个。数据库收录内容表现形式有图片、电子书、视频等，是以视听材料为主的黄河文化专题库。数据库对所收录古地图进行了深度标引和大众化解读，通过数字化形式完成了信息收集和知识架构，作为黄河文化的专题库能为黄河文化的广泛宣传和深入研究提供有效的数据支撑。",
      "id": "8a7b4ed1e49f4ebbac8adfe2c0974b63",
      "images": [],
      "imgUrl": "",
      "isUp": false,
      "keyWord": "",
      "mirrorPrice": 150000,
      "mirrorVersion": 1,
      "netPrice": 50000,
      "netVersion": 1,
      "orgId": "",
      "pageIndex": null,
      "pageSize": null,
      "publishDate": "0001-01-01 00:00:00",
      "publishUnit": "中国水利水电出版社",
      "publishUnitHtml": "中国水利水电出版社",
      "remark": "",
      "sort": 0,
      "status": "1",
      "title": "中国黄河水利古地图数字资源库",
      "titleHtml": "中国黄河水利古地图数字资源库",
      "updateBy": "",
      "updateTime": "0001-01-01 00:00:00",
      "webUrl": "",
      "word": ""
    },
    {
      "areaCode": "北京",
      "bussinessCid": "",
      "contactPerson": "",
      "contactPhone": "",
      "contentCid": "385",
      "contentFrom": "",
      "createBy": "",
      "createTime": "2025-03-20 13:58:50",
      "dataCount": 2000,
      "dataFunction": "",
      "description": "中国水利发展报告数据库使用数字化手段对自2004 年起的《中国水利发展报告》内容资源加以整合、加工、挖掘，充分展示了《中国水利发展报告》的资源特点，实现资源共享、信息增值。",
      "descroptionHtml": "中国水利发展报告数据库使用数字化手段对自2004 年起的《中国水利发展报告》内容资源加以整合、加工、挖掘，充分展示了《中国水利发展报告》的资源特点，实现资源共享、信息增值。",
      "id": "c4f9795a19a74617aff6d5b13dcd99a4",
      "images": [],
      "imgUrl": "",
      "isUp": false,
      "keyWord": "",
      "mirrorPrice": 150000,
      "mirrorVersion": 1,
      "netPrice": 50000,
      "netVersion": 1,
      "orgId": "",
      "pageIndex": null,
      "pageSize": null,
      "publishDate": "0001-01-01 00:00:00",
      "publishUnit": "中国水利水电出版社",
      "publishUnitHtml": "中国水利水电出版社",
      "remark": "",
      "sort": 0,
      "status": "1",
      "title": "中国水利发展报告数据库",
      "titleHtml": "中国水利发展报告数据库",
      "updateBy": "",
      "updateTime": "0001-01-01 00:00:00",
      "webUrl": "",
      "word": ""
    },
    {
      "areaCode": "北京",
      "bussinessCid": "",
      "contactPerson": "",
      "contactPhone": "",
      "contentCid": "385",
      "contentFrom": "",
      "createBy": "",
      "createTime": "2025-03-20 13:58:50",
      "dataCount": 2000,
      "dataFunction": "",
      "description": "“水知识助手”是重点面向水利水电专业知识服务及信息服务领域而打造的内容资源数字化传播平台与知识服务平台，内容涵盖水利水电相关各个学科门类，类型有图书标准、专题数据库、在线课程、水利百科、图片视频等，其中电子图书5000余种，电脑和移动端都可访问。该平台通过深化拓展水利专业内容资源的知识价值，为各界读者提供专业、及时、有效的内容资源与知识服务。",
      "descroptionHtml": "“水知识助手”是重点面向水利水电专业知识服务及信息服务领域而打造的内容资源数字化传播平台与知识服务平台，内容涵盖水利水电相关各个学科门类，类型有图书标准、专题数据库、在线课程、水利百科、图片视频等，其中电子图书5000余种，电脑和移动端都可访问。该平台通过深化拓展水利专业内容资源的知识价值，为各界读者提供专业、及时、有效的内容资源与知识服务。",
      "id": "ca44fde53a774d29b6b6ee8473bfaaf6",
      "images": [],
      "imgUrl": "/profile/knowledge/2025/03/26/cee6ee55-16e7-4365-81a0-3f645dd204e4.png",
      "isUp": false,
      "keyWord": "",
      "mirrorPrice": 150000,
      "mirrorVersion": 1,
      "netPrice": 50000,
      "netVersion": 1,
      "orgId": "",
      "pageIndex": null,
      "pageSize": null,
      "publishDate": "0001-01-01 00:00:00",
      "publishUnit": "中国水利水电出版社",
      "publishUnitHtml": "中国水利水电出版社",
      "remark": "",
      "sort": 0,
      "status": "1",
      "title": "“水知识助手”知识服务平台",
      "titleHtml": "“水知识助手”知识服务平台",
      "updateBy": "",
      "updateTime": "0001-01-01 00:00:00",
      "webUrl": "",
      "word": ""
    },
    {
      "areaCode": "江苏",
      "bussinessCid": "",
      "contactPerson": "",
      "contactPhone": "",
      "contentCid": "385",
      "contentFrom": "",
      "createBy": "",
      "createTime": "2025-03-20 13:58:50",
      "dataCount": 2000,
      "dataFunction": "",
      "description": "数字版大运河的开发团队利用深度学习和计算机视觉技术，重建了运河沿岸的历史场景。 通过高清晰度的三维模型和动态场景，游客可以通过手机或智能设备，以第一人称的视角游历自古以来的运河。 系统结合历史数据和用户反馈，实时更新内容，确保游客能够接收到最新、最准确的信息。 这种技术的应用，使传统文化以全新的方式得以传播，使得更多人能够轻松地接触到中华文化的精髓。",
      "descroptionHtml": "数字版大运河的开发团队利用深度学习和计算机视觉技术，重建了运河沿岸的历史场景。 通过高清晰度的三维模型和动态场景，游客可以通过手机或智能设备，以第一人称的视角游历自古以来的运河。 系统结合历史数据和用户反馈，实时更新内容，确保游客能够接收到最新、最准确的信息。 这种技术的应用，使传统文化以全新的方式得以传播，使得更多人能够轻松地接触到中华文化的精髓。",
      "id": "d991bedb02914deabccdfe81c08c730b",
      "images": [],
      "imgUrl": "/profile/knowledge/2025/03/26/da641a1a-b577-4c32-83a3-769b621fd95a.png",
      "isUp": false,
      "keyWord": "",
      "mirrorPrice": 150000,
      "mirrorVersion": 1,
      "netPrice": 50000,
      "netVersion": 1,
      "orgId": "",
      "pageIndex": null,
      "pageSize": null,
      "publishDate": "0001-01-01 00:00:00",
      "publishUnit": "江苏凤凰出版集团",
      "publishUnitHtml": "江苏凤凰出版集团",
      "remark": "",
      "sort": 0,
      "status": "1",
      "title": "数字中国·大运河文化数字资源库",
      "titleHtml": "数字中国·大运河文化数字资源库",
      "updateBy": "",
      "updateTime": "0001-01-01 00:00:00",
      "webUrl": "",
      "word": ""
    },
    {
      "areaCode": "河南",
      "bussinessCid": "",
      "contactPerson": "",
      "contactPhone": "",
      "contentCid": "385",
      "contentFrom": "",
      "createBy": "",
      "createTime": "2025-03-20 13:58:50",
      "dataCount": 2000,
      "dataFunction": "",
      "description": "",
      "descroptionHtml": "",
      "id": "f570185a2dce4440bb8869abee562f4b",
      "images": [],
      "imgUrl": "",
      "isUp": false,
      "keyWord": "",
      "mirrorPrice": 150000,
      "mirrorVersion": 1,
      "netPrice": 50000,
      "netVersion": 1,
      "orgId": "",
      "pageIndex": null,
      "pageSize": null,
      "publishDate": "0001-01-01 00:00:00",
      "publishUnit": "黄河水利出版社",
      "publishUnitHtml": "黄河水利出版社",
      "remark": "",
      "sort": 0,
      "status": "1",
      "title": "黄河水利资源数据库",
      "titleHtml": "黄河水利资源数据库",
      "updateBy": "",
      "updateTime": "0001-01-01 00:00:00",
      "webUrl": "",
      "word": ""
    }
  ]
)

const collapseItems = [
  {
    title: "解决方案",
    name: "1",
    contents: [
      {
        id: '0',
        text: "知识库建设方案",
        content:
          "<p>在数字浪潮的冲击下，出版行业正面临内容碎片化加剧、多元格式资源管理繁杂、读者需求日趋个性化等多重挑战。为有效应对这些难题，知识库的建设显得尤为重要。知识库深度整合出版社多年沉淀的核心资源，涵盖具有独家性、稀缺性与专业性的学术文献、出版内容、信息数据、技术工具及平台资产等。通过运用先进的数据采集分析技术、智能文献资源管理系统与深度挖掘工具，实现对海量异构资源的系统性梳理与高效整合。这一数字化基础设施不仅能够大幅提升资料共享效率，还能加速研究成果的传播与转化，为出版行业的创新发展注入强劲动力。</p> <p>以 <strong>知识库建</strong>设为核心，提供全文检索、知识图谱、个性化推荐等多元化服务；依托<strong>大数据资产中心</strong>，通过结构化数据处理和AI技术将多源资源转化为标准化知识资产；底层 <strong>基础能力建设</strong> 保障系统安全与高效运行。其特点为智能化服务、多模态资源兼容及用户导向设计，适用于教育、科研及企业场景，实现知识的高效存储、管理与精准应用。</p> <p>核心功能：</p><p>1.多维导航：打破传统线性浏览模式，构建多维度资源导航体系。从多个维度对知识进行重组，用户可根据研究方向、学习需求或兴趣偏好，快速定位目标内容，大幅提升知识检索效率。</p><p>2.知识检索：依托先进的检索算法与智能分词技术，支持关键词、主题词、全文检索等多种方式，实现毫秒级响应。</p> <p>3.知识关联：通过语义分析与机器学习技术，挖掘知识间潜在联系，构建知识网络。用户在浏览某一内容时，系统自动推荐相关主题、参考文献、相似案例等关联信息，实现知识的横向拓展与纵向深入，助力用户发现知识新视角，激发创新思维。</p><p>4.用户中心：作为用户个性化服务中枢，集成个人信息管理、资源收藏、学习记录、浏览历史等功能。用户可根据自身偏好定制界面风格、设置推送提醒。</p><p>5.知识图谱：以可视化方式呈现知识结构与关系网络，将零散的知识点串联成体系化知识脉络。通过知识图谱，用户能够直观了解学科领域全貌、关键知识节点及其相互关系，辅助进行知识梳理、学术研究与决策分析，为知识创新与应用提供清晰的认知框架。</p>",
        category: "历史文化",
        text: "知识库建设方案",
        house: '西北大学出版社',
        fileName: 'a',
        date: '2024-11-26',
        way: '网络访问',
        num: '200家',
        url: iamge

      },
      {
           id: '1',
        text: "全流程AI数字出版平台",
        content: "<p>亿知全流程数字出版平台，包涵出版管理平台及内容创作系统，为出版社数字出版工作提供全方位的支持。同时从内容创作、编辑加工到市场推广、读者互动，都能通过AI技术实现智能化、精准化和高效化。出版社可以更好地满足读者需求，提升图书销量和品牌影响力，同时降低运营成本。</p><p>一、功能特点：</p> <p> 1.AI辅助创作：基于大模型（如Deepseek）实现初稿生成、章节扩写、摘要提炼，覆盖小说、教材、工具书等多元体裁，提升创作效率。</p> <p>2.智能审校：通过NLP技术检测语法错误、敏感词、逻辑矛盾及事实性错误，提高准确率，降低人工校对成本。</p> <p>3.智能排版：AI根据目标载体（纸质书、电子书、音频）自动适配版式，如电子书动态分页、纸质书插图智能匹配、音频章节切分，节省排版用时。</p> <p>4.AI制图：基于文本描述与多维度参数指令（如风格、构图、细节约束），生成符合需求的高质量图像，支持动态调整与多模态输出适配。</p>  <p>5.版权合规筛查：内置AI版权库比对，实时预警内容侵权风险，规避法律纠纷。</p>  <p> 二、精准营销与用户增长</p>  <p>1.个性化推荐系统：基于用户画像（阅读偏好、消费行为）与协同过滤算法，实现“千人千面”的资源推荐，提高转化率。</p> <p>2.阅读行为分析：AI追踪用户阅读进度、标注热点内容，动态生成“兴趣标签库”，辅助二次营销策略制定。</p> <p>3.选题预测分析：通过分析社交媒体热点、搜索趋势及竞品数据，预测潜在爆款题材（如元宇宙科普、轻养生指南），提升市场采纳率。</p><p>4.库存智能调控：结合销量预测与区域需求分析，动态调整印刷量与仓储分布，降低滞销风险20%以上。 </p><p>5.AI营销素材工厂：自动生成短视频、社交媒体文案，产出适配各平台的传播内容。<p/> <p>6.虚拟主播互动：AI数字人解读新书亮点，直播带货并实时解答读者提问，转化效率较传统直播有所提升。</p>",
        url: image2,
      },
      {
           id: '2',
        text: "出版社本地模型部署",
        content: "<p>随着数字化转型加速，非结构化数据激增，传统数据处理模式难以满足智能分析需求。人工智能数据中台支持集成AI大模型能力，构建企业智能化中枢，实现数据资产沉淀、知识高效利用及业务流程优化，提供了低门槛的智能化工具，助力客户实现以下目标</p> <p>1.数据资产化：构建统一知识库，打通文本等多源数据；</p>  <p>2.业务智能化：提供对话、创作、模拟等AI工具，赋能运营与决策；</p> <p>3.服务敏捷化：支持私有部署与API扩展，快速响应业务需求。</p> <p>中台对接本地私有化部署DeepSeek深度思考大模型，以及多个功能模块，可覆盖日常工作多个关键环节，可自定义智能体。支持本地知识库快速构建，支持知识库的密级管理。通过“模型指令+知识库+业务对接”的三层增强架构，保障模型能够“越用越懂业务”，为客户提供更加智能化、个性化的服务。</p>",
        url: image3
      }
    ]
  },

]

export {
  knowledgeCards,
  cards,
  imgUrlList,
  newData,
  collapseItems
}